import { getCmcTokenArray } from "./get-cmc-token-array";
import { getMarketMetaArray } from "./get-market-meta-array";
import { getMarketProtocolKeyMap } from "./get-market-protocol-key-map";
import { getShareTokenMeta } from "./get-share-token-meta";
import { getTokenPriceMap } from "./get-token-price-map";
import { getUnpopulatedCmcTokens } from "./get-unpopulated-cmc-tokens";
import { getTokenPriceKey } from "./keys";
import {
  getMerklCampaignMeta,
  setMerklCampaignMeta,
} from "./merkl-campaign-meta";
import {
  getMerklUserRewardsInfo,
  setMerklUserRewardsInfo,
} from "./merkl-user-rewards-info";
import { setCmcMeta } from "./set-cmc-meta";
import { setCmcPrice } from "./set-cmc-price";
import { KvService, KvTokenPrice } from "./types";
import { updateMarketMeta } from "./update-market-meta";

export const KvClient = {
  KvService,
  KvTokenPrice,

  getCmcTokenArray,
  getMarketMetaArray,
  getMarketProtocolKeyMap,
  getMerklCampaignMeta,
  getMerklUserRewardsInfo,
  getShareTokenMeta,
  getTokenPriceMap,
  getUnpopulatedCmcTokens,
  setCmcMeta,
  setCmcPrice,
  setMerklCampaignMeta,
  setMerklUserRewardsInfo,
  updateMarketMeta,

  getTokenPriceKey,
};
